<template>
  <div class="panelNagusia">
    <div class="ui breadcrumb">
      <a class="section" v-on:click="goTo('/dashboard')">Home</a>
      <i class="right angle icon divider"></i>
      <a class="active section" v-on:click="goTo('/inventory')">Inventario y Actuaciones</a>
      <i class="right angle icon divider"></i>
      <a class="active section" v-on:click="goTo('/inventory/stock/list')">Stocks</a>
      <i class="right angle icon divider"></i>
      <a class="active section">Añadir Stock</a>
    </div>

    <h1 class="ui header"><i class="dolly icon"></i>
      <div class="content">Nuevo Stock</div>
    </h1>

    <div class="ui stackable one column divided grid container">
      <div class="row">
        <div class="column">
          <form class="ui form">
            <h4 class="ui dividing header">Datos Stock</h4>
            <div class="field">
              <label>Nombre*</label>
              <input type="text" id="idStockName" v-model="newStock.stockName" placeholder="Nombre Stock"/>
            </div>
            <div class="field">
              <label>Tipo Stock*</label>
              <sui-dropdown fluid selection id="idStockType" :options="stockTypesOptions" v-model="newStock.stockType" placeholder="Tipo Stock"/>
            </div>
            <div class="field" v-if="newStock.stockType === 'C'">
              <label>Nº Slots</label>
              <input type="number" min="0" id="idNSlots" v-model="newStock.nSlots" placeholder="Nº Slots"/>
            </div>
            <div class="field">
              <label>Máquinas*</label>
              <sui-dropdown fluid multiple search selection id="idStockAptModel" :options="stockAptModelOptions" v-model="newStock.stockAptModel" placeholder="Tipo Stock"/>
            </div>
            <div class="field">
              <label>Proveedor*</label>
              <sui-dropdown fluid search selection id="idProvider" :options="providerOptions" v-model="newStock.provider" placeholder="Proveedor"/>
            </div>
            <div class="field" id="idBtns">
              <button id="idCrear" class="ui button" type="button" v-on:click="createNewStock">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  </template>
  <script>
  import { hapiickApi } from '@/api/hapiickApi';
  export default {
    name: 'stockAdd',
    data() {
      return {
        newStock: {
          stockType: null,
          stockName: null,
          nSlots: null,
          minimunQuantity: null,
          stockAptModel: [],
          provider:null,
          active: 1,
          desglose: 1
        },
        stockTypesOptions: [],
        stockAptModelOptions: [],
        providerOptions: [],
      }
    },
    created() {
      let role = JSON.parse(localStorage.admin).role
      if (role === 'master' || role === 'admin') {
        this.getStockTypes()
        this.getDataFilters()
      } else {
        this.$router.replace('/inventory')
      }
    },
    methods: {
      initializeStyles(){
        let borderNone = "border-color: none !important"
        document.getElementById("idStockName").style = borderNone
        document.getElementById("idStockType").style = borderNone
        document.getElementById("idStockAptModel").style = borderNone
        document.getElementById("idProvider").style = borderNone

        let idNSlots = document.getElementById("idNSlots")
        if (idNSlots) {
          idNSlots.style = borderNone
        }
      },
      createNewStock(){
        this.initializeStyles();
        let next = true;

        if (!this.newStock.stockType 
        || !this.newStock.stockName 
        || !this.newStock.provider 
        || (this.newStock.stockType === 'C' && !this.newStock.nSlots)
        || (this.newStock.stockAptModel.length === 0)) {
          next = false
          this.$swal.fire({
            type: 'warning',
            title: '',
            text: 'Algun campo obligatorio esta vacio'
          })
        }

        let borderError = "border: 1px solid red !important"

        if (!this.newStock.stockName) {
          document.getElementById("idStockName").style = borderError
        }
        if (!this.newStock.stockType) {
          document.getElementById("idStockType").style = borderError
        }
        if (this.newStock.stockType === 'C' && !this.newStock.nSlots) {
          document.getElementById("idNSlots").style = borderError
        }
        if (this.newStock.stockAptModel.length === 0) {
          document.getElementById("idStockAptModel").style = borderError
        }
        if (!this.newStock.provider) {
          document.getElementById("idProvider").style = borderError
        }

        if (next) {
          let x = document.getElementById("idCrear");
          x.classList.add("loading");
          x.disabled = true;

          hapiickApi().post('/v1/stocks/add', {
            admin_id: JSON.parse(localStorage.admin).id,
            newStock: this.newStock
          })
          .then(request => {
            if (request.data.status === 'OK') {
              this.$swal({
                type: 'success',
                title: 'Los datos se han guardado correctamente',
                showConfirmButton: false,
                timer: 2500
              })
              this.initializeComponent();
            } else {
              this.$swal({
                type: 'error',
                title: 'Error',
                text: request.data.message
              })
            }
            x.classList.remove("loading");
            x.disabled = false;
          })
          .catch((request) => {
            console.log('error creating new stock: ' + request)
          })
        }
      },
      initializeComponent() {
        this.newStock.stockType = null
        this.newStock.stockName = null
        this.newStock.nSlots = null
        this.newStock.stockAptModel = []
        this.newStock.active = 1
        this.newStock.desglose = 1
        this.newStock.provider = null
      },
      async getStockTypes() {
        await this.axios.get("static/tipo_stock.json").then(response => {
          let stockTypes = response.data.stockTypes;
          let stockTypesOptions = stockTypes.map((e) => {
            return {
              text: e.text,
              value: e.key,
            }
          })
          this.stockTypesOptions = stockTypesOptions.sort((a, b) => {
            if ( a.text < b.text ){
              return -1;
            }
            if ( a.text > b.text ){
              return 1;
            }
            return 0;
          })
        })
        .catch((request) => console.log('error getting stock types: ' + request));
      },
      async getDataFilters() {
        await hapiickApi().post('/v2/shipments/filters', {
          admin_id: JSON.parse(localStorage.admin).id,
          AptModel: true,
          Provider: true
        })
        .then(request => {
          this.fillStockAptModelOptions(JSON.parse(JSON.stringify(request.data.data.aptModels)))
          this.fillProviderOptions(JSON.parse(JSON.stringify(request.data.data.provider)))
        })
        .catch(() => console.log('error getting combo filters'))
      },
      fillStockAptModelOptions(data) {
        for (let i = 0; i < data.length; i++) {
          this.stockAptModelOptions.push({
            id: data[i].AptModel.id,
            key: data[i].AptModel.id,
            text: data[i].AptModel.name.toString(),
            value: data[i].AptModel.id,
          })
        }
      },
      fillProviderOptions(data) {
        for (let i = 0; i < data.length; i++) {
          this.providerOptions.push({
            id: data[i].Provider.id,
            key: data[i].Provider.id,
            text: data[i].Provider.name.toString(),
            value: data[i].Provider.id,
          })
        }
      },
      redirect() {
        let routeData = this.$router.resolve('/inventory/stock/list');
        window.open(routeData.href,'_self');
      },     
      goTo(where) {
        this.$router.push(where)
      },
    },
  }
</script>
<style scoped>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

input[type=number] { 
  -moz-appearance: textfield;
  appearance: textfield;
}

#idBtns {
  display: flex;
  justify-content: center; 
}

#idCrear {
  background-color: black!important;
  color: white;
  width: 35%;
}
</style>



// WEBPACK FOOTER //
// src/components/Inventory/stockAdd.vue